<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap-acw"><a id="a82"></a>Acknowledgements for Portraits and Maps</h2>
<p class="hang"><a id="page_viii"></a>Burne, Lieutenant Colonel A.H., <em class="italic">Mesopotamia, the Last Phase</em>, Gale and Polden (nd)</p>
<p class="hang">Candler, Edward, <em class="italic">The Long Road to Baghdad</em>, Vols I &amp; II, Cassell (1919)</p>
<p class="hang">Dunsterville, Major General L.C., <em class="italic">The Adventures of Dunsterforce</em>, Edward Arnold (1920)</p>
<p class="hang">Marshall, William, <em class="italic">Memories of Four Fronts</em>, Ernest Benn (1929)</p>
<p class="hang">Moberley, Brigadier General F.J., <em class="italic">The Campaign in Mesopotamia 1914</em><em class="italic">–1918</em>, Official History, Stationery Office, Vol I, 1923, Vol II 1924</p>
<p class="hang">Mousley, E.O., <em class="italic">The Secrets of a Kuttite</em>, Bodley Head (1922)</p>
<p class="hang">One of its Officers, <em class="italic">With a Highland Regiment in Mesopotamia 1916</em><em class="italic">–1917</em>, The Times Press, Bombay (1918)</p>
<p class="hang">Sherson, Erroll, <em class="italic">Townshend of Chitral and Kut</em>, Heinemann (1928)</p>
<p class="hang">Staff College, Quetta, <em class="italic">Critical Study of the Campaign in Mesopotamia up to April 1917</em>, Government of India, Calcutta (1925)</p>
<p class="hang">Tennant, Lieutenant Colonel J.E., <em class="italic">In the Clouds above Baghdad</em>, Cecil Palmer (1920)</p>
<p class="hang">Wilson, Sir Arnold, <em class="italic">Loyalties</em> <em class="italic">– Mesopotamia, 1914–1917</em>, OUP (1929)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Ack.vue?07e58928